// redux/slices/propertySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

// -------------------- Async Thunks --------------------

// Fetch all properties
export const fetchProperties = createAsyncThunk(
  "property/fetchProperties",
  async () => {
    const res = await api.get("/api/properties");
    return res.data; // assuming API returns array of properties directly
  }
);

// Add a new property
export const addProperty = createAsyncThunk(
  "property/addProperty",
  async (data) => {
    const res = await api.post("/api/properties", data);
    return res.data.data; // only the property object
  }
);

// Update existing property
export const updateProperty = createAsyncThunk(
  "property/updateProperty",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await api.post(`/api/properties/${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return res.data.data;
    } catch (err) {
      console.log("Update Error:", err.response.data);
      return rejectWithValue(err.response.data);
    }
  }
);


// Delete property
export const deleteProperty = createAsyncThunk(
  "property/deleteProperty",
  async (id) => {
    await api.delete(`/api/properties/${id}`);
    return { id };
  }
);

// -------------------- Slice --------------------

const propertySlice = createSlice({
  name: "property",
  initialState: {
    list: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchProperties.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProperties.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload;
      })
      .addCase(fetchProperties.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // Add
      .addCase(addProperty.fulfilled, (state, action) => {
        if (!Array.isArray(state.list)) state.list = [];
        state.list.push(action.payload); // payload is property object
      })

      // Update
      .addCase(updateProperty.fulfilled, (state, action) => {
        if (!Array.isArray(state.list)) {
          console.log("action payload", action.payload);
          state.list = [] ;
          state.list.push(action.payload);
        }
        const index = state.list.findIndex((p) => p.id === action.payload.id);
        if (index >= 0) {
          state.list[index] = action.payload; // replace old property
        } else {
          state.list.push(action.payload);
        }
      })

      // Delete
      .addCase(deleteProperty.fulfilled, (state, action) => {
        if (Array.isArray(state.list)) {
          state.list = state.list.filter(
            (item) => item.id !== action.payload.id
          );
        }
      });
  },
});

export default propertySlice.reducer;
